import { environment } from 'environments/environment';

export function isLocalProjectPreviewEnabled(): boolean {
  return !environment.production && environment.hmr && typeof location !== 'undefined'
    && ['localhost', '127.0.0.1'].includes(location.hostname);
}
